var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctionApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a2c88306-fa03-4e5b-b192-401f0b77808b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b403aca7-f387-4434-96b4-ae157edc835f",
    x1: -175.993,
    y1: -343.723,
    x2: -175.993,
    y2: -359.232,
    gradientTransform: "translate(212.573 370.548) scale(1.156 1.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fea11b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#fea51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#feb018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffc314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd70f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-compute-29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.37,7.475H3.2a.267.267,0,0,1,.267.267v6.148a.533.533,0,0,1-.533.533H2.1a0,0,0,0,1,0,0V7.741a.267.267,0,0,1,.267-.267Z",
    transform: "translate(12.507 16.705) rotate(134.919)",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.325,3.6h.833a.267.267,0,0,1,.267.267v6.583a0,0,0,0,1,0,0H2.591a.533.533,0,0,1-.533-.533V3.865A.267.267,0,0,1,2.325,3.6Z",
    transform: "translate(5.759 0.114) rotate(44.919)",
    fill: "#1490df"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.53,7.475h.833a.533.533,0,0,1,.533.533v6.148a.267.267,0,0,1-.267.267H14.8a.267.267,0,0,1-.267-.267V7.475a0,0,0,0,1,0,0Z",
    transform: "translate(12.223 -7.555) rotate(45.081)",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.108,3.6h.833a0,0,0,0,1,0,0v6.583a.267.267,0,0,1-.267.267h-.833a.267.267,0,0,1-.267-.267V4.131a.533.533,0,0,1,.533-.533Z",
    transform: "translate(31.022 1.222) rotate(135.081)",
    fill: "#1490df"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.459,9.9H4.87a.193.193,0,0,1-.2-.181.166.166,0,0,1,.018-.075L8.991,1.13a.206.206,0,0,1,.186-.106h4.245a.193.193,0,0,1,.2.181.165.165,0,0,1-.035.1L8.534,7.966h4.928a.193.193,0,0,1,.2.181.176.176,0,0,1-.052.122L5.421,16.788c-.077.046-.624.5-.356-.189h0Z",
    fill: "url(#b403aca7-f387-4434-96b4-ae157edc835f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionApps);
export default __webpack_public_path__ + "static/media/FunctionApps.4f40b8975768422a62d22483a8f9632f.svg";
export { ForwardRef as ReactComponent };